var crypto = require('crypto');

var AESCrypt = {};

AESCrypt.encrypt = function (cryptKey, crpytIv, plainData) {
  var encipher = crypto.createCipheriv('aes-256-cbc', cryptKey, crpytIv),
    encrypted = encipher.update(plainData, 'utf8', 'binary');

  encrypted += encipher.final('binary');

  return Buffer.from(encrypted, 'binary').toString('base64');
};

AESCrypt.decrypt = function (cryptKey, cryptIv, encrypted) {
  encrypted = Buffer.from(encrypted, 'base64').toString('binary');

  var decipher = crypto.createDecipheriv('aes-256-cbc', cryptKey, cryptIv),
    decrypted = decipher.update(encrypted, 'binary', 'utf8');

  decrypted += decipher.final('utf8');

  return decrypted;
};

module.exports = AESCrypt;